// Mock data for Asian Film Festival

export const featuredFilm = {
  title: "Silent Echoes",
  director: "Park Chan-wook",
  festival: "Guwahati Asian Film Festival 2027",
  date: "11-14 FEB",
  location: "IN GUWAHATI /",
  rating: "",
  totalRatings: "",
  cast: [
  "SONG KANG-HO",
  "TANG WEI",
  "KEN WATANABE",
  "RAJKUMMAR RAO"]

};

export const filmGallery = [
{
  id: 1,
  title: "Midnight Rain",
  category: "Drama",
  duration: "2:15",
  type: "video",
  isNew: true,
  thumbnail: "https://images.unsplash.com/photo-1580478654182-8bd34b9c0b8d"
},
{
  id: 2,
  title: "Tokyo Dreamers",
  category: "Romance",
  duration: "1:58",
  type: "video",
  isNew: true,
  thumbnail: "https://images.unsplash.com/photo-1580478341213-659047bb025c"
},
{
  id: 3,
  title: "The Last Letter",
  category: "Thriller",
  type: "image",
  thumbnail: "https://images.pexels.com/photos/8271453/pexels-photo-8271453.jpeg"
},
{
  id: 4,
  title: "Shadow Warriors",
  category: "Action",
  type: "image",
  thumbnail: "https://images.pexels.com/photos/8271459/pexels-photo-8271459.jpeg"
},
{
  id: 5,
  title: "Monsoon Heart",
  category: "Drama",
  type: "image",
  thumbnail: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba"
},
{
  id: 6,
  title: "Spring in Seoul",
  category: "Romance",
  type: "image",
  thumbnail: "https://images.unsplash.com/photo-1527979809431-ea3d5c0c01c9"
}];


export const festivalProgram = [
{
  id: 1,
  date: "11",
  month: "FEB",
  title: "PARASITE: REMASTERED",
  times: ["11:00", "15:00", "19:30"],
  image: "https://images.pexels.com/photos/5504120/pexels-photo-5504120.jpeg"
},
{
  id: 2,
  date: "11",
  month: "FEB",
  title: "IN THE MOOD FOR LOVE",
  times: ["12:30", "16:00", "20:00"],
  image: "https://images.pexels.com/photos/3137890/pexels-photo-3137890.jpeg"
},
{
  id: 3,
  date: "12",
  month: "FEB",
  title: "TRAIN TO BUSAN: DIRECTOR'S CUT",
  times: ["10:00", "14:30", "18:30"],
  image: "https://images.pexels.com/photos/15811754/pexels-photo-15811754.jpeg"
},
{
  id: 4,
  date: "13",
  month: "FEB",
  title: "SPIRITED AWAY: 20TH ANNIVERSARY",
  times: ["11:00", "15:00", "19:00"],
  image: "https://images.pexels.com/photos/30704104/pexels-photo-30704104.jpeg"
},
{
  id: 5,
  date: "14",
  month: "FEB",
  title: "BURNING",
  times: ["13:00", "17:00", "21:00"],
  image: "https://images.unsplash.com/photo-1597151429502-99101cf1c79f"
}];


export const shopProducts = [
{
  id: 1,
  title: "Parasite Poster",
  price: 28.00,
  category: "Drama",
  image: "https://images.unsplash.com/photo-1667238374285-ea0ad594ab0d",
  status: "available"
},
{
  id: 2,
  title: "Tokyo Stories Print",
  price: 15.00,
  category: "Romance",
  image: "https://images.unsplash.com/photo-1626814026160-2237a95fc5a0",
  status: "available"
},
{
  id: 3,
  title: "Vintage Cinema",
  price: 28.00,
  category: "Mystery",
  image: "https://images.pexels.com/photos/3137890/pexels-photo-3137890.jpeg",
  status: "sold"
},
{
  id: 4,
  title: "Festival Collection",
  price: 14.00,
  originalPrice: 28.00,
  category: "Fantasy",
  image: "https://images.unsplash.com/photo-1758786266368-30dd993cfdaf",
  status: "sale"
}];


export const testimonials = [
{
  id: 1,
  name: "K Hung",
  role: "Participant Filmmaker",
  quote: "I am so glad that my film can be screened in Guwahati Asian Film Festival. I was impressed by the effort and passion of the entire festival team. The program and activities are well curated. I had the chance to meet with various filmmakers, critics, and audiences in India. The hospitality is great. I had a great time in Guwahati!",
  image: "https://images.unsplash.com/photo-1580478654182-8bd34b9c0b8d"
},
{
  id: 2,
  name: "Bishal Swargiary",
  role: "Participant Filmmaker",
  quote: "It was an amazing experience to be part of such an esteemed festival.",
  image: "https://images.pexels.com/photos/8271453/pexels-photo-8271453.jpeg"
},
{
  id: 3,
  name: "Aaryan Chandra Prakash",
  role: "Participant Filmmaker",
  quote: "I had a beautiful experience at GAFF, and I feel the Guwahati Asian Film Festival has the potential to grow into an important space for cinema in India and across Asia. Festivals like GAFF feel necessary because they create room for these voices and perspectives.",
  image: "https://images.pexels.com/photos/8271459/pexels-photo-8271459.jpeg"
},
{
  id: 4,
  name: "Pankaj Borah",
  role: "Participant Filmmaker",
  quote: "Heartfelt thanks to the Guwahati Asian Film Festival for organizing the festival in such a brilliant and seamless manner. Every detail reflected the passion, hard work, and vision behind it. The dedication and commitment of the entire organizing team truly deserve special appreciation.",
  image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba"
}];


export const portfolioItems = [
{
  id: 1,
  title: "S",
  category: "Japan",
  image: "https://static.wixstatic.com/media/e775bf_1746f4a2d33d45379f79f8159ce5f516~mv2.png"
},
{
  id: 2,
  title: "Sunday",
  category: "Uzbekistan",
  image: "https://static.wixstatic.com/media/e775bf_d2bb14d6e5aa4f0091c45a9ddf8e7d98~mv2.jpg"
},
{
  id: 3,
  title: "MA Cry of Silence",
  category: "Myanmar",
  image: "https://static.wixstatic.com/media/e775bf_ba5cc355b27e4bc2989ea2f7d1367ee3~mv2.jpg"
},
{
  id: 4,
  title: "In The Land of Brothers",
  category: "Iran",
  image: "https://static.wixstatic.com/media/e775bf_e93bc12a980944dc8449ccbbabd55135~mv2.jpg"
},
{
  id: 5,
  title: "If Only I Could Hibernate",
  category: "Mongolia",
  image: "https://static.wixstatic.com/media/e775bf_0bb6a94786284ce59670d79e658ca536~mv2.png"
},
{
  id: 6,
  title: "Culi Never Cries",
  category: "Vietnam",
  image: "https://static.wixstatic.com/media/e775bf_20c1a9e1bac54aa0be370cd15e87bccf~mv2.jpg"
},
{
  id: 7,
  title: "The Shore of Life",
  category: "China",
  image: "https://static.wixstatic.com/media/e775bf_bf2e45c710de4321b6ac6c09ab009057~mv2.jpg"
},
{
  id: 8,
  title: "A Poet of the River",
  category: "South Korea",
  image: "https://static.wixstatic.com/media/e775bf_c6a5e616863448bbafd1c1a648da9c2b~mv2.jpg"
},
{
  id: 9,
  title: "Cadet",
  category: "Kazakhstan",
  image: "https://static.wixstatic.com/media/e775bf_df0c09b7209f4951a529f08fe687e2a4~mv2.jpg"
},
{
  id: 10,
  title: "Let's Have A Cup of Doodh Patti Chai",
  category: "Hong Kong",
  image: "https://static.wixstatic.com/media/e775bf_656413ef553d42348ba62cce55f42f2e~mv2.jpg"
}];


export const sponsors = [
{ 
  id: 1, 
  name: "GMDA",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/zo3yqlnu_GMDA%20Logo_edited.avif"
},
{ 
  id: 2, 
  name: "Life's Purple Association",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/1exb6w1w_Life%27s%20Purple%20-%20Association-With-Background.avif"
},
{ 
  id: 3, 
  name: "NFDC",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/5gl0t5xu_NFDC.avif"
},
{ 
  id: 4, 
  name: "NRL",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/1nsfsw9x_nrl.avif"
},
{ 
  id: 5, 
  name: "Alchemy Pixels",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/5ee21jok_AP%20white%20logo.png"
},
{ 
  id: 6, 
  name: "ONGC",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/dloj9l0k_ONGC_Logo.avif"
},
{ 
  id: 7, 
  name: "Awesome Assam",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/4mtax7nu_Awesome_Assam_Logo.avif"
},
{ 
  id: 8, 
  name: "Ministry of Information and Broadcasting",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/rde6y2or_Ministry_of_Information_and_Broadcasting_svg.avif"
},
{ 
  id: 9, 
  name: "Partner Organization",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/fzvwe9st_309387618_460802482746171_7111659069415169555_n.avif"
},
{ 
  id: 10, 
  name: "Festival Supporter",
  logo: "https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/imlua0vh_WhatsApp%20Image%202026-01-15%20at%2022_20_24.avif"
}];